function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialMediaButtons = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _targets = require("./targets");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var SocialMediaButtons = exports.SocialMediaButtons = (0, _react.memo)(function (_ref) {
  var shareable = _ref.shareable,
    style = _ref.style,
    targets = _ref.targets;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  if ((shareable == null ? void 0 : shareable.url) === '' || (shareable == null ? void 0 : shareable.url) == undefined) return null;
  return (0, _jsxRuntime.jsx)(_reactNative.View, {
    style: [styles.row, style],
    testID: "SocialMediaButtons",
    children: (targets != null ? targets : _targets.socialMediaTargets).map(function (e) {
      return (0, _jsxRuntime.jsx)(_reactNative.TouchableOpacity, {
        accessibilityLabel: t('socialMediaButtons:ariaLabel', {
          value: e.name
        }),
        style: [styles.button],
        onPress: function onPress() {
          return e.onClick(shareable);
        },
        testID: "tid-".concat(e.name),
        children: (0, _jsxRuntime.jsx)(_reactNative.View, {
          style: [styles.icon, {
            backgroundColor: e.color
          }],
          children: (0, _jsxRuntime.jsx)(e.icon, {})
        })
      }, "k-".concat(e.name));
    })
  });
});